// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tyvt","name":"styles_name__3mzvv","phone":"styles_phone__2O3X9"};